import React, { FC } from 'react'
import { usePosition } from 'use-position'
import { MAP } from '../constants/routes'
import { PageTitleSection } from '../components/common/ui/PageTitleSection'
import { ClientListMap } from '../components/map/ClientListMap'
import Loader from '../components/loader/Loader'
import Alerts from '../components/alerts/Alerts'
import { STATUS } from '../enums/common'
import { ROUTES } from '../enums/routes'
import { MapSearchSection } from '../components/map/MapSearchSection'
import { PlaceholderMessage } from '../components/common/ui/PlaceholderMessage'
import { StickyWrapper } from '../components/common/ui/StickyWrapper'
import { useLoadClientsHook } from '../hooks/UseLoadClientsHook'

const MapPage: FC = () => {
  const {
    filters,
    status,
    message,
    setFilters,
    changePage,
    fieldsData,
    offset,
    currentPage,
    waitToLoadClientData,
    placeholderMessageProps,
    clients,
    search,
    getAccountsPortfolioRoute,
    backRoute,
  } = useLoadClientsHook()

  const geolocation = usePosition()
  const { latitude, longitude } = geolocation

  const mapProps = {
    clients,
    latitude,
    longitude,
    hasSearchData: !!filters.search || !!search,
    backRoute: backRoute ?? '',
    offset,
    currentPage,
  }

  return (
    <section className="pageContentWrapper portfolioPage pl75">
      <div className="px3 py3">
        <PageTitleSection pageName={MAP} />
        <StickyWrapper>
          <Alerts status={status} message={message ?? ''} />
        </StickyWrapper>
        <MapSearchSection
          setFilters={setFilters}
          filters={filters}
          fieldsData={fieldsData}
          changePage={changePage}
          routes={{
            accountsPortfolio: getAccountsPortfolioRoute(),
          }}
          resetRoute={ROUTES.map}
        />
        {(waitToLoadClientData || (status && status === STATUS.PENDING)) && (
          <Loader />
        )}
        {clients && clients.length > 0 && <ClientListMap {...mapProps} />}
        {!waitToLoadClientData && (
          <PlaceholderMessage {...placeholderMessageProps} />
        )}
      </div>
    </section>
  )
}

export default MapPage
